import { render, staticRenderFns } from "./cartShop.vue?vue&type=template&id=1b842fc0&"
import script from "./cartShop.vue?vue&type=script&lang=js&"
export * from "./cartShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports